// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__Pfl0z","rotation":"Loading_rotation__oZBQF","overlay":"Loading_overlay__mxtB8","animloader":"Loading_animloader__LRvD9"};